@for (filter of filters; track filter) {
  <div
    class="filter flex {{ filter.options.appearance }}"
    #element
    [ngClass]="{ active: activeFilter === filter.categoryId }"
    [class.multi]="filter.type === 'multi'"
    [ngStyle]="style(filter)"
  >
    @if (filter.localStorage) {
      @switch (filter.options.appearance) {
        <!-- <ng-container *ngSwitchCase="'timeline'">
        <timeline-control [items]="filter.localStorage.filterObjects" [(selected)]="filter.selectedValue" (selectedChange)="updateFilter(filter)" [style]="style">
        </timeline-control>
      </ng-container> -->
        <!-- <ng-container *ngSwitchCase="'slider'">
      <items-slider [(ngModel)]="filter.selectedValue" (ngModelChange)="updateFilter(filter)" [items]="filter.localStorage.filterObjects" [style]="style">
      </items-slider>
    </ng-container> -->
        <!-- TODO make drodown dependant on filter Type -->
        @case ('dropdown') {
          <ng-container>
            <!-- [below]="true" -->
            <menu-button
              [scrollStrategy]="'close'"
              [close]="closeSelect"
              [withBackdrop]="false"
              [hideShadow]="true"
              [autoclose]="true"
              [overlayStyle]="{ borderTopLeftRadius: 0 }"
              [menuStyle]="{ backgroundColor: 'transparent' }"
              (isOpen)="opened($event, filter.categoryId)"
              [originPosition]="getPopupPosition(filter.categoryId).originPosition"
              [overlayPosition]="getPopupPosition(filter.categoryId).overlayPosition"
              [showOverflow]="true"
              [connectToElement]="element"
            >
              <button class="title center flex" button>
                <ng-container>
                  {{ filter.options.customLabel || categories[filter.categoryId].label }}
                </ng-container>
                <!-- <ng-template #mulitHeader>
            {{ filter.options.customTitle }}
            <span
              *ngIf="filter.selectedValues.length > 0 && filter.selectedValues.length != filter.localStorage.filterObjects.length"
            class="counter flex center">{{ filter.selectedValues.length }}</span>
          </ng-template> -->
                <div class="open-icon" [class.r180]="activeFilter === filter.categoryId">
                  <i class="icon-down-open center flex"></i>
                </div>
                <!-- <div class="down-arrow"></div> -->
              </button>
              <div
                #list
                class="list"
                [style.minWidth.px]="element.clientWidth"
                [style.padding]="filter.style.dropdown.popup.container.padding | responsiveStyle: 'spacing'"
                [style.boxShadow]="filter.style.dropdown.popup.container.boxShadow | responsiveStyle: 'shadow'"
                [style.borderRadius.px]="filter.style.dropdown.popup.container.borderRadius"
                [style.backgroundColor]="filter.style.dropdown.popup.container.background.backgroundColor"
              >
                <list-selector
                  [items]="filter.localStorage.categoryValues"
                  [multiSelect]="filter.type === 'multi'"
                  [ngModel]="filter.localStorage.selectedValueIds"
                  [valueField]="'id'"
                  [labelField]="'label'"
                  [placeholder]="filter.style.dropdown.popup.search.placeholder"
                  [itemInactiveOpacity]="filter.style.dropdown.popup.items.inactive.opacity"
                  [itemMouseOver]="{
                    backgroundColor: filter.style.dropdown.popup.items.mouseOver.background.backgroundColor,
                    color: filter.style.dropdown.popup.items.mouseOver.color,
                  }"
                  [itemActive]="{
                    backgroundColor: filter.style.dropdown.popup.items.active.background.backgroundColor,
                    color: filter.style.dropdown.popup.items.active.color,
                  }"
                  [selectAllText]="filter.style.dropdown.popup.selectAllButton.label"
                  [showSearch]="filter.style.dropdown.popup.search.enabled"
                  [autoSort]="false"
                  [trackByFn]="trackByFunction"
                  [itemFont]="filter.style.dropdown.popup.items.font | responsiveStyle"
                  [measureElement]="element"
                  (newPositions)="setPopupPositions(filter.categoryId, $event)"
                  (ngModelChange)="setValues(filter, $event)"
                ></list-selector>
              </div>
            </menu-button>
          </ng-container>
        }
      }
    }
  </div>
}
